import { HelpToggletip, TopTooltip } from 'ui/tooltip';
import { YES_NO_SPLIT_RADIO_OPTIONS } from '../YesNoSplitEditor.constants';
import { isStartTileUnfilterable, isUndeterminableOrigin } from '../YesNoSplitEditor.utils';
import { Description } from './Description';

export const getRadioOptions = ({
  startNodeClass = '',
  isReadOnly = false,
  isMatchTriggeringEventSelected = false,
}: {
  startNodeClass: string;
  isReadOnly: boolean;
  isMatchTriggeringEventSelected: boolean;
}) => {
  const [userOption, eventOption] = YES_NO_SPLIT_RADIO_OPTIONS;
  const isUnfilterable = isStartTileUnfilterable(startNodeClass);
  const isUndeterminable = isUndeterminableOrigin(startNodeClass);

  return [
    { ...userOption, isDisabled: isReadOnly },
    {
      ...eventOption,
      isDisabled: isReadOnly || isUnfilterable,
      ...(!isUnfilterable && {
        description: <Description isAllEventsSelected={!isMatchTriggeringEventSelected} />,
      }),
      label: (
        <TopTooltip
          isEnabled={isUnfilterable}
          tooltipContent={'This journey’s entry source is not an event.'}
        >
          {eventOption.label}
          {isUndeterminable && isMatchTriggeringEventSelected && (
            <HelpToggletip
              iconProps={{ height: 20, width: 20 }}
              tooltipContent={
                'Since this journey’s entry source is "Other journey", the specific triggering event(s) can’t be shown here.'
              }
            />
          )}
        </TopTooltip>
      ),
    },
  ];
};
